<template>
  <v-main>

    <v-container class="fill-height" fluid>
    <ResetPassword />
    </v-container>
  </v-main>
</template>

<script>
import ResetPassword from "./ResetPassword.vue";
export default {
  name: "index.vue",
  components: {
    ResetPassword,
  },
  data() {
    return {};
  },
}
</script>

<style scoped>

</style>